import { type OnereDTO } from '@framework/api-client/api/inquiries-compile/schemas/onereDTO.ts';

/**
 * L'ufficio destinatario del pagamento va mostrato solo quando differisce da
 * quello responsabile: quando coincidono l'informazione è ridondante.
 *
 * Entrambe le denominazioni arrivano denormalizzate in
 * `oneri[].datiRiepilogo`, valorizzato sempre e non solo per il Backoffice,
 * quindi la condizione dipende dai dati dell'onere e non dalla sorgente del
 * riepilogo.
 */
export function hasDistinctRecipientOffice(burden: OnereDTO): boolean {
  const recipient =
    burden.datiRiepilogo?.denominazioneUfficioDestinatarioPagamento;
  const responsible = burden.datiRiepilogo?.denominazioneUfficioResponsabile;

  return recipient != null && recipient !== responsible;
}
